import React, { Component } from 'react';
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import * as actions from "../actions/acBookingFlow"

import { fetchFutureBookings, fetchPastBookings, fetchMoreBookings,
	bookingsMetaChange, bookingsUIChange, sendReview, resetBookingState } from '../actions/acBookings'

import { PootsyTitle, PootsyButton } from './DesignFunctions'
import BookingLine from './BookingLine'
import ReviewModal from './ReviewModal'
import StarRaters from './StarRaters'

import womanHoldingPhoneIcon from "../static/img/woman-holding-phone-icon.png"

class Bookings extends Component {
	state = {
		now: moment(),
		reviewModalPrefill: 0
	}
	componentWillMount = () => {
		this.props.dispatch(fetchFutureBookings())
		this.props.dispatch(fetchPastBookings())
	}
	componentWillUnmount = () => {
		this.props.dispatch(resetBookingState())
	}
	fetchMoreBookings = () => {
		this.props.dispatch(fetchMoreBookings())
	}
	toggleReviewModal = () => {
		let { dispatch, ui: { showReviewModal } } = this.props
		dispatch(bookingsUIChange({ showReviewModal: !showReviewModal }))
	}
	submitReview = review => {
		this.props.dispatch(sendReview(review))
	}
	handlerTypeChange = e => {
		this.props.dispatch(bookingsMetaChange({ type: e.target.dataset.type }))
	}
	prefillReviewModal = grade => {
		this.setState({ reviewModalPrefill: grade }, () => { this.toggleReviewModal() })
	}
	render() {
		let { t } = this.context
		let { reviewModalPrefill } = this.state
		let { ui, meta, bookings } = this.props
		let finishedBookings = bookings.past.filter(b => ['finished', 'finished_without_confirmation'].includes(b.status))
		let lastFinishedBooking = finishedBookings.reduce((acc, b, i, arr) => b.start.isAfter(acc.start, 'day') ? b : acc, finishedBookings[0])
		let allowLastFinishedBookingRating = lastFinishedBooking && !lastFinishedBooking.review
		let lastFinishedBookingRating = (lastFinishedBooking && lastFinishedBooking.review) ? lastFinishedBooking.review.rating : 0
		return(
			<div className="Bookings">
				{ui.showReviewModal &&
					<ReviewModal
						toggleModal={this.toggleReviewModal}
						sendReview={this.submitReview}
						gradePrefill={reviewModalPrefill}
						booking={lastFinishedBooking}
					/>
				}
				<div className="left">
					<div className="header">
						<PootsyTitle title={t("my_services")}/>
						<div className="types">
							<div className={"type " + (meta.type === 'future' ? "active" : "")} onClick={this.handlerTypeChange} data-type="future">
								{t('future_bookings')}
							</div>
							<div className={"type " + (meta.type === 'past' ? "active" : "")} onClick={this.handlerTypeChange} data-type="past">
								{t('past_bookings')}
							</div>
						</div>
					</div>
					<div className={"bookings " + meta.type}>
						{this.renderBookingList(allowLastFinishedBookingRating, lastFinishedBooking)}
					</div>
					{meta.moreBookingsAvailable[meta.type] &&
						<div className="show-more" onClick={this.fetchMoreBookings}>{t('show_more')}</div>
					}
				</div>
				<div className="right">
					{this.renderNewBookingLink()}
					{lastFinishedBooking &&
						<div className="rate-booking-box">
							<PootsyTitle title={t('what_did_you_think_of_last_service')}/>
							<StarRaters value={lastFinishedBookingRating} onChange={this.prefillReviewModal} disabled={!allowLastFinishedBookingRating}/>
							<div className="last-finished-booking-info">
								{`${t('service_happened_at_date')} ${lastFinishedBooking.start.format('DD.MM.YYYY')}`}<br/>
								{`${t('service_delivered_by')} ${lastFinishedBooking.workerName}`}
							</div>
						</div>
					}
					<div className="share-pootsy-box">
						<div className="top">
							<img className="share-woman-icon" alt="share" src={womanHoldingPhoneIcon}/>
						</div>
						<div className="bottom">
							<div className="heading">
								<PootsyTitle title={t('do_you_like_pootsy')}/>
								<div className="subtext">{t('share_pootsy_with_friends')}</div>
							</div>
							<div className="share-networks">
								<div className="network facebook">
									<a target="_blank" rel="noopener noreferrer"
										href="https://www.facebook.com/sharer/sharer.php?u=https%3A//www.facebook.com/pootsyapp/"
									>
										{t('share_on_facebook')}
									</a>
								</div>
								<div className="network twitter">
									<a target="_blank" rel="noopener noreferrer"
										href={"https://twitter.com/home?status=" + encodeURI(t('twitter_sharing_message'))}
									>
										{t('share_on_twitter')}
									</a>
								</div>
								<div className="network mail">
									<a href={"mailto:?&subject=Pootsy&body=" + encodeURI(t('mail_sharing_message'))}>
										{t('share_with_email')}
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="problem-contact">
					</div>
				</div>
			</div>
		)
	}


	renderBookingList = (allowLastFinishedBookingRating, lastFinishedBooking) => {
		let { meta, bookings } = this.props

		if (bookings.future.length === 0 && meta.type === 'future') {
			return (
				<div className="no-booking">
					{this.renderNewBookingLink()}
				</div>
			)
		}
		else {
			return (
				bookings[meta.type].map(b =>
				<BookingLine
					key={b.id + b.start.format()} booking={b}
					showReview={allowLastFinishedBookingRating && b.id === lastFinishedBooking.id}
					prefillReviewModal={this.prefillReviewModal}
				/>
			)
			)
		}
	}

	renderNewBookingLink = () => {
		let { t } = this.context

		return (
			<Link to="/booking-flow">
				<PootsyButton text={t("new_booking")} onClick={this.startNewBooking}/>
			</Link>
		)
	}

	startNewBooking = () => {
		this.props.dispatch(actions.startBookingFlow())
	}
}

Bookings.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	bookings: state.dataReducer.bookings,
	ui: state.uiReducer.bookings,
	meta: state.metadataReducer.bookings
})
export default connect(mapStateToProps)(Bookings);



// WEBPACK FOOTER //
// ./src/components/Bookings.js